import addPublicAuthTokenHeader from '@baserow/modules/database/utils/publicView'

export default (client) => {
  return {
    get(slug, publicAuthToken = null) {
      const config = { headers: {} }
      if (publicAuthToken) {
        addPublicAuthTokenHeader(config, publicAuthToken)
      }
      return client.get(`/saas/form-safety/${slug}/`, config)
    },
  }
}
